import { createContext } from "react"

//* Valid values: none | custom;
const ThemeContext = createContext('custom');
export default ThemeContext;